import { render, staticRenderFns } from "./UnableToShipReasons.vue?vue&type=template&id=6cb0ba46&scoped=true&"
import script from "./UnableToShipReasons.vue?vue&type=script&lang=js&"
export * from "./UnableToShipReasons.vue?vue&type=script&lang=js&"
import style0 from "./UnableToShipReasons.vue?vue&type=style&index=0&id=6cb0ba46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb0ba46",
  null
  
)

export default component.exports